import { ReactComponent as ErrorBoundariesIconSvg } from 'assets/icons/error-screen-icon.svg'

import { IconStyles } from '../types'
import { ErrorBoundariesIcon as ErrorBoundariesIconComponent } from './styles'
interface UploadProps extends IconStyles {
  onClick?: any
  filter?: boolean
}

const ErrorBoundariesIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  size,
}: UploadProps) => {
  return (
    <ErrorBoundariesIconComponent
      size={size}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
    >
      <ErrorBoundariesIconSvg />
    </ErrorBoundariesIconComponent>
  )
}

export default ErrorBoundariesIcon
